export default "./images/survio-1c_f9-assets-dashboards.png";